module.exports = __webpack_public_path__ + "img/bg-texture.jpg";